import Head from 'next/head';
import { Footer, Header } from '../../components';
import previewMain from '../../public/preview/preview-nft.jpg';

import menu from '../../utils/menu';
import NFT from './nft';

function NFTPage(): JSX.Element {
  return (
    <>
      <Head>
        <title>
          Mavinx NFT Development Services: Unlocking Non-Fungible Token
          Potential
        </title>
        <meta
          property="og:title"
          content="Mavinx NFT Development Services: Unlocking Non-Fungible Token
          Potential"
        />
        <meta property="og:image" content={`${previewMain.src}`} />
        <meta name="twitter:image" content={`${previewMain.src}`} />
        <meta
          property="og:image:alt"
          content="Mavinx NFT Development Services: Unlocking Non-Fungible Token
          Potential"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Mavinx's NFT development services unleash NFTs' potential for digital assets and collectibles. Discover how our blockchain, smart contract, and DApp experience can help creators, artists, and companies tokenize and monetize their unique digital assets. NFTs' demonstrated ownership, scarcity, and immutability are transforming art, gaming, real estate, and more. Mavinx is your NFT development partner."
        />
        <meta
          name="description"
          content="Mavinx's NFT development services unleash NFTs' potential for digital assets and collectibles. Discover how our blockchain, smart contract, and DApp experience can help creators, artists, and companies tokenize and monetize their unique digital assets. NFTs' demonstrated ownership, scarcity, and immutability are transforming art, gaming, real estate, and more. Mavinx is your NFT development partner."
        />
        <meta
          name="keywords"
          content="NFT development services, Mavinx NFT, non-fungible tokens, NFTs, digital assets, collectibles, blockchain technology, smart contracts, decentralized applications, DApps, tokenization, asset monetization, proven ownership, scarcity, immutability, NFT industries, art, gaming, real estate, transformative technology, Mavinx NFT development"
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin=""
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap"
          rel="stylesheet"
        />
      </Head>
      <Header
        appearance="transparent"
        appearanceNav="nft"
        appearanceLogo="nft"
        menu={menu}
      />
      <NFT />
      <Footer />
    </>
  );
}

export default NFTPage;
